import * as React from "react";
import './radioButtonListControl.component.scss';
import {RadioButtonListControlComponentOptionProps} from "../../types/types";
import useBelfiusTheme from "../leadgeneration/theme/ThemeHooks";

export const RadioButtonListControlComponent = ( {name, onChange, options}: RadioButtonListControlComponentOptionProps ) => {
    let {themeClassName} = useBelfiusTheme();

    const handleKeyPress = ( e: any ) => {
        if ( e.key === 'Enter' && e.shiftKey === false ) {
            e.preventDefault();
        }

    };

    return (<div className={`custom-radio-list d-flex flex-column align-items-center mb-3 w-100 ${themeClassName}`} data-toggle="buttons">
        {options.map( ( option ) => {
            let className = "btn btn-default custom-radio form-check";
            className += option.selected ? " selected" : "";

            return (<label key={option.key} htmlFor={option.value} className={className} onClick={( e ) => onChange( option.value )}>
                <input id={option.value} type="radio" name={name} value={option.value}
                       checked={option.selected}
                       onKeyPress={handleKeyPress}
                />
                <span className={"text"}>{option.text}</span>
            </label>);
        } )}

    </div>)
}
